/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
/* tslint:disable: no-duplicate-imports this is a change */
import { IModuleProps, INodeProps } from '@msdyn365-commerce-modules/utilities';
import * as Msdyn365 from '@msdyn365-commerce/core';
import { AttributeValue } from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceTypes.g';
import classnames from 'classnames';
import { reaction } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import  { getAttributesForSelectedVariant }  from '@msdyn365-commerce-modules/product-specification';
import  { AttributesForSelectedVariantInput }  from '@msdyn365-commerce-modules/product-specification';


import { IAbsoluteFullChartsData } from './absolute-full-charts.data';
import { IAbsoluteFullChartsProps } from './absolute-full-charts.props.autogenerated';

export interface IProductSpecificationViewProps extends IAbsoluteFullChartsProps<{}> {
    ProductSpecification: IModuleProps;
    ProductSpecificationTableProps: INodeProps;
    ProductSpecificationTableBodyProps: INodeProps;
    productSpecificationResult?: (JSX.Element | null)[];
    title?: React.ReactNode;
    onlinetitle?: React.ReactNode;
    

}

/**
 *
 * ProductSpecification component
 * @extends {React.Component<IAbsoluteFullChartsProps<IAbsoluteFullChartsData>>}
 */
@observer
class ProductSpecification extends React.Component<IAbsoluteFullChartsProps<IAbsoluteFullChartsData>> {
    public async componentDidMount(): Promise<void> {
        const { context, data, telemetry } = this.props;

        // @ts-ignore: Compiler not reconizing condition check for function params
        reaction(
            () => (data.product.result ? data.product.result.RecordId : null),
            () => {
                if (context && data.product.result) {
                    //@ts-ignore
                    const actionInput = new AttributesForSelectedVariantInput(
                        data.product.result.RecordId,
                        // @ts-ignore
                        +context.actionContext.requestContext.apiSettings.channelId,
                        data.product.result
                    );
                        //@ts-ignore
                    getAttributesForSelectedVariant(actionInput, this.props.context.actionContext).catch(error => {
                        telemetry.warning(error);
                        telemetry.debug('Unable to update attributes for Product');
                        telemetry.error(error);
                    });
                }
            }
        );
    }

    // tslint:disable-next-line:max-func-body-length
    public render(): JSX.Element | null {
        let data: IAbsoluteFullChartsData;

        try {
            data = this.props.data;
        } catch (e) {
            this.props.telemetry.error(`Something went wrong ------${e}`);
            //@ts-ignore
            return <div>{e}</div>;
        }

        if (!data.productSpecificationData.result || data.productSpecificationData.result.length <= 0) {
            this.props.telemetry.error('Product specification content is empty, module wont render.');
            return null;
        }

        const { className } = this.props.config;

        

        
        const { productSpecificationData } = this.props.data;

        const viewProps = {
            ...this.props,
            

            ProductSpecification: {
                moduleProps: this.props,
                className: classnames('locally', className)
            },
            ProductSpecificationTableProps: {
                className: classnames('nick-test'),
                tag: 'span'
            },
            ProductSpecificationTableBodyProps: {
                className: '',
                tag: 'div'
            },
            //@ts-ignore
            productSpecificationResult: productSpecificationData && this._createTableBody(data)
        } as IProductSpecificationViewProps;

        return this.props.renderView(viewProps) as React.ReactElement;
    }
    
    private _createTableBody(content: IAbsoluteFullChartsData): (JSX.Element | null)[] {
        //@ts-ignore
        return content.productSpecificationData.result!.map((product, index) => {
            const cellData: JSX.Element | null = this._renderProductCell(product);

            if (!cellData) {
                return null;
            }
            
            if (product.TextValue === "Child") {

                const child = `<div class="default-container default-container__1 fluid table-control">
                <div class="row">
                    <div class="col-md-6">
                        <table class="sizing product-chart">
                            <tr>
                                <th class="table-row">Product Description</th>
                            </tr>
                            <tr class="table-row row-1 product-description" id="" data-m-t="absolute-chart-container">
                                <td class="table-row-column row-1 product-description">
                                    <div class="ms-text-block tr-one" id="text-block__0" data-m-t="text-block">
                                        <div disabled="" contenteditable="false">
                                            <p>
                                                LITTLE DIPPERS,<br />
                                                WATER BUDDIES,<br />
                                                CHILD &amp; YOUTH NYLON,<br />
                                                TEEN NYLON,<br />
                                                CHILD &amp; YOUTH RAPID-DRY,<br />
                                                JUNIOR RAPID-DRY,<br />
                                                CHILD &amp; YOUTH RAPID-DRY/FLEX-BACK
                                            </p>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <div class="col-md-6">
                        <table class="sizing product-chart">
                            <tr>
                                <th class="table-row">Size</th>
                                <th class="table-row">Chest</th>
                                <th class="table-row">Weight</th>
                            </tr>
                            <tr class="table-row row-4" id="" data-m-t="absolute-chart-container">
                                <td class="table-row-column row-4">
                                    <div class="ms-text-block" id="text-block__1" data-m-t="text-block">
                                        <div disabled="" contenteditable="false">
                                            <p>Child</p>
                                        </div>
                                    </div>
                                </td>
                                <td class="table-row-column row-4">
                                    <div class="ms-text-block" id="text-block__2" data-m-t="text-block">
                                        <div disabled="" contenteditable="false">
                                            <p>- - - -</p>
                                        </div>
                                    </div>
                                </td>
                                <td class="table-row-column row-4">
                                    <div class="ms-text-block" id="text-block__3" data-m-t="text-block">
                                        <div disabled="" contenteditable="false">
                                            <p>33-55 Lbs.</p>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr class="table-row row-4" id="" data-m-t="absolute-chart-container">
                                <td class="table-row-column row-4">
                                    <div class="ms-text-block" id="text-block__13" data-m-t="text-block">
                                        <div disabled="" contenteditable="false">
                                            <p>Youth</p>
                                        </div>
                                    </div>
                                </td>
                                <td class="table-row-column row-4">
                                    <div class="ms-text-block" id="text-block__14" data-m-t="text-block">
                                        <div disabled="" contenteditable="false">
                                            <p>- - - -</p>
                                        </div>
                                    </div>
                                </td>
                                <td class="table-row-column row-4">
                                    <div class="ms-text-block" id="text-block__15" data-m-t="text-block">
                                        <div disabled="" contenteditable="false">
                                            <p>55-88 Lbs.</p>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr class="table-row row-4" id="" data-m-t="absolute-chart-container">
                                <td class="table-row-column row-4">
                                    <div class="ms-text-block" id="text-block__13" data-m-t="text-block">
                                        <div disabled="" contenteditable="false">
                                            <p>Junior</p>
                                        </div>
                                    </div>
                                </td>
                                <td class="table-row-column row-4">
                                    <div class="ms-text-block" id="text-block__14" data-m-t="text-block">
                                        <div disabled="" contenteditable="false">
                                            <p>28" - 32"</p>
                                        </div>
                                    </div>
                                </td>
                                <td class="table-row-column row-4">
                                    <div class="ms-text-block" id="text-block__15" data-m-t="text-block">
                                        <div disabled="" contenteditable="false">
                                            <p>77-125 Lbs.</p>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr class="table-row row-4" id="" data-m-t="absolute-chart-container">
                                <td class="table-row-column row-4">
                                    <div class="ms-text-block" id="text-block__13" data-m-t="text-block">
                                        <div disabled="" contenteditable="false">
                                            <p>Teen</p>
                                        </div>
                                    </div>
                                </td>
                                <td class="table-row-column row-4">
                                    <div class="ms-text-block" id="text-block__14" data-m-t="text-block">
                                        <div disabled="" contenteditable="false">
                                            <p>28" - 32"</p>
                                        </div>
                                    </div>
                                </td>
                                <td class="table-row-column row-4">
                                    <div class="ms-text-block" id="text-block__15" data-m-t="text-block">
                                        <div disabled="" contenteditable="false">
                                            <p>90 Lbs. and Over</p>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </table>
                    </div>       
                </div>
            </div>
                `;

                return (
                    
                    <div className="fifty" dangerouslySetInnerHTML={{ __html: child, }} />




                    

                );
            }
            if (product.TextValue === "Adult Ski") {

                const adultSki = `<div class="default-container default-container__1 fluid table-control">
                <div class="row">
                    <div class="col-md-6">
                        <table class="sizing product-chart">
                            <tr>
                                <th class="table-row">Product Description</th>
                            </tr>
                            <tr class="table-row row-1 product-description" id="" data-m-t="absolute-chart-container">
                                <td class="table-row-column row-1 product-description">
                                    <div class="ms-text-block tr-one" id="text-block__0" data-m-t="text-block">
                                        <div disabled="" contenteditable="false">
                                            <p>ADULT UNIVERSAL SKI</p>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <div class="col-md-6">
                        <table class="sizing product-chart">
                            <tr>
                                <th class="table-row">Size</th>
                                <th class="table-row">Chest</th>
                                <th class="table-row">Weight</th>
                            </tr>
                            <tr class="table-row row-4" id="" data-m-t="absolute-chart-container">
                                <td class="table-row-column row-4">
                                    <div class="ms-text-block" id="text-block__1" data-m-t="text-block">
                                        <div disabled="" contenteditable="false">
                                            <p>Adult Universal</p>
                                        </div>
                                    </div>
                                </td>
                                <td class="table-row-column row-4">
                                    <div class="ms-text-block" id="text-block__2" data-m-t="text-block">
                                        <div disabled="" contenteditable="false">
                                            <p>30" - 52"</p>
                                        </div>
                                    </div>
                                </td>
                                <td class="table-row-column row-4">
                                    <div class="ms-text-block" id="text-block__3" data-m-t="text-block">
                                        <div disabled="" contenteditable="false">
                                            <p>90 Lbs. and Over</p>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr class="table-row row-4" id="" data-m-t="absolute-chart-container">
                                <td class="table-row-column row-4">
                                    <div class="ms-text-block" id="text-block__13" data-m-t="text-block">
                                        <div disabled="" contenteditable="false">
                                            <p>Adult Oversize</p>
                                        </div>
                                    </div>
                                </td>
                                <td class="table-row-column row-4">
                                    <div class="ms-text-block" id="text-block__14" data-m-t="text-block">
                                        <div disabled="" contenteditable="false">
                                            <p>40" - 60"</p>
                                        </div>
                                    </div>
                                </td>
                                <td class="table-row-column row-4">
                                    <div class="ms-text-block" id="text-block__15" data-m-t="text-block">
                                        <div disabled="" contenteditable="false">
                                            <p>90 Lbs. and Over</p>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </table>
                    </div>       
                </div>
            </div>
                `;

                return (
                    
                    <div className="fifty" dangerouslySetInnerHTML={{ __html: adultSki, }} />

                );
            }

            if (product.TextValue === "Adult Nylon") {

                const adultNylon = `<div class="default-container default-container__1 fluid table-control">
                <div class="row">
                    <div class="col-md-6">
                        <table class="sizing product-chart">
                            <tr>
                                <th class="table-row">Product Description</th>
                            </tr>
                            <tr class="table-row row-1 product-description" id="" data-m-t="absolute-chart-container">
                                <td class="table-row-column row-1 product-description">
                                    <div class="ms-text-block tr-one" id="text-block__0" data-m-t="text-block">
                                        <div disabled="" contenteditable="false">
                                            <p>
                                                ADULT NYLON,<br />
                                                ADULT RAPID-DRY
                                            </p>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <div class="col-md-6">
                        <table class="sizing product-chart">
                            <tr>
                                <th class="table-row">Size</th>
                                <th class="table-row">Chest</th>
                                <th class="table-row">Weight</th>
                            </tr>
                            <tr class="table-row row-4" id="" data-m-t="absolute-chart-container">
                                <td class="table-row-column row-4">
                                    <div class="ms-text-block" id="text-block__1" data-m-t="text-block">
                                        <div disabled="" contenteditable="false">
                                            <p>Small / Medium</p>
                                        </div>
                                    </div>
                                </td>
                                <td class="table-row-column row-4">
                                    <div class="ms-text-block" id="text-block__2" data-m-t="text-block">
                                        <div disabled="" contenteditable="false">
                                            <p>32" - 40"</p>
                                        </div>
                                    </div>
                                </td>
                                <td class="table-row-column row-4">
                                    <div class="ms-text-block" id="text-block__3" data-m-t="text-block">
                                        <div disabled="" contenteditable="false">
                                            <p>90 Lbs. and Over</p>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr class="table-row row-4" id="" data-m-t="absolute-chart-container">
                                <td class="table-row-column row-4">
                                    <div class="ms-text-block" id="text-block__13" data-m-t="text-block">
                                        <div disabled="" contenteditable="false">
                                            <p>Large / X-Large</p>
                                        </div>
                                    </div>
                                </td>
                                <td class="table-row-column row-4">
                                    <div class="ms-text-block" id="text-block__14" data-m-t="text-block">
                                        <div disabled="" contenteditable="false">
                                            <p>40" - 52"</p>
                                        </div>
                                    </div>
                                </td>
                                <td class="table-row-column row-4">
                                    <div class="ms-text-block" id="text-block__15" data-m-t="text-block">
                                        <div disabled="" contenteditable="false">
                                            <p>90 Lbs. and Over</p>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr class="table-row row-4" id="" data-m-t="absolute-chart-container">
                                <td class="table-row-column row-4">
                                    <div class="ms-text-block" id="text-block__13" data-m-t="text-block">
                                        <div disabled="" contenteditable="false">
                                            <p>2X-Large / 3X-Large</p>
                                        </div>
                                    </div>
                                </td>
                                <td class="table-row-column row-4">
                                    <div class="ms-text-block" id="text-block__14" data-m-t="text-block">
                                        <div disabled="" contenteditable="false">
                                            <p>50" - 60"</p>
                                        </div>
                                    </div>
                                </td>
                                <td class="table-row-column row-4">
                                    <div class="ms-text-block" id="text-block__15" data-m-t="text-block">
                                        <div disabled="" contenteditable="false">
                                            <p>90 Lbs. and Over</p>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr class="table-row row-4" id="" data-m-t="absolute-chart-container">
                                <td class="table-row-column row-4">
                                    <div class="ms-text-block" id="text-block__13" data-m-t="text-block">
                                        <div disabled="" contenteditable="false">
                                            <p>4X-Large / 7X-Large</p>
                                        </div>
                                    </div>
                                </td>
                                <td class="table-row-column row-4">
                                    <div class="ms-text-block" id="text-block__14" data-m-t="text-block">
                                        <div disabled="" contenteditable="false">
                                            <p>60" - 70"</p>
                                        </div>
                                    </div>
                                </td>
                                <td class="table-row-column row-4">
                                    <div class="ms-text-block" id="text-block__15" data-m-t="text-block">
                                        <div disabled="" contenteditable="false">
                                            <p>90 Lbs. and Over</p>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </table>
                    </div>       
                </div>
            </div>
                `;

                return (
                    
                    <div className="fifty" dangerouslySetInnerHTML={{ __html: adultNylon, }} />

                );
            }


            if (product.TextValue === "Adult Rapid") {

                const adultRapid = `<div class="default-container default-container__1 fluid table-control">
                <div class="row">
                    <div class="col-md-6">
                        <table class="sizing product-chart">
                            <tr>
                                <th class="table-row">Product Description</th>
                            </tr>
                            <tr class="table-row row-1 product-description" id="" data-m-t="absolute-chart-container">
                                <td class="table-row-column row-1 product-description">
                                    <div class="ms-text-block tr-one" id="text-block__0" data-m-t="text-block">
                                        <div disabled="" contenteditable="false">
                                            <p>
                                                ADULT RAPID-DRY FLEX-BACK
                                            </p>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <div class="col-md-6">
                        <table class="sizing product-chart">
                            <tr>
                                <th class="table-row">Size</th>
                                <th class="table-row">Chest</th>
                                <th class="table-row">Weight</th>
                            </tr>
                            <tr class="table-row row-4" id="" data-m-t="absolute-chart-container">
                                <td class="table-row-column row-4">
                                    <div class="ms-text-block" id="text-block__1" data-m-t="text-block">
                                        <div disabled="" contenteditable="false">
                                            <p>X-Small</p>
                                        </div>
                                    </div>
                                </td>
                                <td class="table-row-column row-4">
                                    <div class="ms-text-block" id="text-block__2" data-m-t="text-block">
                                        <div disabled="" contenteditable="false">
                                            <p>28" - 32"</p>
                                        </div>
                                    </div>
                                </td>
                                <td class="table-row-column row-4">
                                    <div class="ms-text-block" id="text-block__3" data-m-t="text-block">
                                        <div disabled="" contenteditable="false">
                                            <p>90 Lbs. and Over</p>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr class="table-row row-4" id="" data-m-t="absolute-chart-container">
                                <td class="table-row-column row-4">
                                    <div class="ms-text-block" id="text-block__13" data-m-t="text-block">
                                        <div disabled="" contenteditable="false">
                                            <p>Small</p>
                                        </div>
                                    </div>
                                </td>
                                <td class="table-row-column row-4">
                                    <div class="ms-text-block" id="text-block__14" data-m-t="text-block">
                                        <div disabled="" contenteditable="false">
                                            <p>32" - 36"</p>
                                        </div>
                                    </div>
                                </td>
                                <td class="table-row-column row-4">
                                    <div class="ms-text-block" id="text-block__15" data-m-t="text-block">
                                        <div disabled="" contenteditable="false">
                                            <p>90 Lbs. and Over</p>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr class="table-row row-4" id="" data-m-t="absolute-chart-container">
                                <td class="table-row-column row-4">
                                    <div class="ms-text-block" id="text-block__13" data-m-t="text-block">
                                        <div disabled="" contenteditable="false">
                                            <p>Medium</p>
                                        </div>
                                    </div>
                                </td>
                                <td class="table-row-column row-4">
                                    <div class="ms-text-block" id="text-block__14" data-m-t="text-block">
                                        <div disabled="" contenteditable="false">
                                            <p>36" - 40"</p>
                                        </div>
                                    </div>
                                </td>
                                <td class="table-row-column row-4">
                                    <div class="ms-text-block" id="text-block__15" data-m-t="text-block">
                                        <div disabled="" contenteditable="false">
                                            <p>90 Lbs. and Over</p>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr class="table-row row-4" id="" data-m-t="absolute-chart-container">
                                <td class="table-row-column row-4">
                                    <div class="ms-text-block" id="text-block__13" data-m-t="text-block">
                                        <div disabled="" contenteditable="false">
                                            <p>Large</p>
                                        </div>
                                    </div>
                                </td>
                                <td class="table-row-column row-4">
                                    <div class="ms-text-block" id="text-block__14" data-m-t="text-block">
                                        <div disabled="" contenteditable="false">
                                            <p>40" - 44"</p>
                                        </div>
                                    </div>
                                </td>
                                <td class="table-row-column row-4">
                                    <div class="ms-text-block" id="text-block__15" data-m-t="text-block">
                                        <div disabled="" contenteditable="false">
                                            <p>90 Lbs. and Over</p>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr class="table-row row-4" id="" data-m-t="absolute-chart-container">
                                <td class="table-row-column row-4">
                                    <div class="ms-text-block" id="text-block__13" data-m-t="text-block">
                                        <div disabled="" contenteditable="false">
                                            <p>X-Large</p>
                                        </div>
                                    </div>
                                </td>
                                <td class="table-row-column row-4">
                                    <div class="ms-text-block" id="text-block__14" data-m-t="text-block">
                                        <div disabled="" contenteditable="false">
                                            <p>44" - 48"</p>
                                        </div>
                                    </div>
                                </td>
                                <td class="table-row-column row-4">
                                    <div class="ms-text-block" id="text-block__15" data-m-t="text-block">
                                        <div disabled="" contenteditable="false">
                                            <p>90 Lbs. and Over</p>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr class="table-row row-4" id="" data-m-t="absolute-chart-container">
                                <td class="table-row-column row-4">
                                    <div class="ms-text-block" id="text-block__13" data-m-t="text-block">
                                        <div disabled="" contenteditable="false">
                                            <p>2X-Large</p>
                                        </div>
                                    </div>
                                </td>
                                <td class="table-row-column row-4">
                                    <div class="ms-text-block" id="text-block__14" data-m-t="text-block">
                                        <div disabled="" contenteditable="false">
                                            <p>48" - 52"</p>
                                        </div>
                                    </div>
                                </td>
                                <td class="table-row-column row-4">
                                    <div class="ms-text-block" id="text-block__15" data-m-t="text-block">
                                        <div disabled="" contenteditable="false">
                                            <p>90 Lbs. and Over</p>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr class="table-row row-4" id="" data-m-t="absolute-chart-container">
                                <td class="table-row-column row-4">
                                    <div class="ms-text-block" id="text-block__13" data-m-t="text-block">
                                        <div disabled="" contenteditable="false">
                                            <p>3X-Large</p>
                                        </div>
                                    </div>
                                </td>
                                <td class="table-row-column row-4">
                                    <div class="ms-text-block" id="text-block__14" data-m-t="text-block">
                                        <div disabled="" contenteditable="false">
                                            <p>52" - 56"</p>
                                        </div>
                                    </div>
                                </td>
                                <td class="table-row-column row-4">
                                    <div class="ms-text-block" id="text-block__15" data-m-t="text-block">
                                        <div disabled="" contenteditable="false">
                                            <p>90 Lbs. and Over</p>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </table>
                    </div>       
                </div>
            </div>
                `;

                return (
                    
                    <div className="fifty" dangerouslySetInnerHTML={{ __html: adultRapid, }} />

                );
            }


            if (product.TextValue === "Infant") {

                const infant = `<div class="default-container default-container__1 fluid table-control">
                <div class="row">
                    <div class="col-md-6">
                        <table class="sizing product-chart">
                            <tr>
                                <th class="table-row">Product Description</th>
                            </tr>
                            <tr class="table-row row-1 product-description" id="" data-m-t="absolute-chart-container">
                                <td class="table-row-column row-1 product-description">
                                    <div class="ms-text-block tr-one" id="text-block__0" data-m-t="text-block">
                                        <div disabled="" contenteditable="false">
                                            <p>
                                                INFANT BABY-SAFE, INFANT NYLON, INFANT RAPID-DRY, INFANT FLEX-BACK, INFANT/CHILD CHARACTER
                                            </p>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <div class="col-md-6">
                        <table class="sizing product-chart">
                            <tr>
                                <th class="table-row">Size</th>
                                <th class="table-row">Chest</th>
                                <th class="table-row">Weight</th>
                            </tr>
                            <tr class="table-row row-4" id="" data-m-t="absolute-chart-container">
                                <td class="table-row-column row-4">
                                    <div class="ms-text-block" id="text-block__1" data-m-t="text-block">
                                        <div disabled="" contenteditable="false">
                                            <p>Infant</p>
                                        </div>
                                    </div>
                                </td>
                                <td class="table-row-column row-4">
                                    <div class="ms-text-block" id="text-block__2" data-m-t="text-block">
                                        <div disabled="" contenteditable="false">
                                            <p>- - - -</p>
                                        </div>
                                    </div>
                                </td>
                                <td class="table-row-column row-4">
                                    <div class="ms-text-block" id="text-block__3" data-m-t="text-block">
                                        <div disabled="" contenteditable="false">
                                            <p>Less than 30 Lbs.</p>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr class="table-row row-4" id="" data-m-t="absolute-chart-container">
                                <td class="table-row-column row-4">
                                    <div class="ms-text-block" id="text-block__13" data-m-t="text-block">
                                        <div disabled="" contenteditable="false">
                                            <p>Infant / Child</p>
                                        </div>
                                    </div>
                                </td>
                                <td class="table-row-column row-4">
                                    <div class="ms-text-block" id="text-block__14" data-m-t="text-block">
                                        <div disabled="" contenteditable="false">
                                            <p>- - - -</p>
                                        </div>
                                    </div>
                                </td>
                                <td class="table-row-column row-4">
                                    <div class="ms-text-block" id="text-block__15" data-m-t="text-block">
                                        <div disabled="" contenteditable="false">
                                            <p>Less Than 50 Lbs.</p>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            
                        </table>
                    </div>       
                </div>
            </div>
                `;

                return (
                    
                    <div className="fifty" dangerouslySetInnerHTML={{ __html: infant, }} />

                );
            }


            return (
                null
            );
        });
    }

    private _renderProductCell(product: AttributeValue): JSX.Element | null {
        switch (product.DataTypeValue) {
            case 0: // none
                // Return span here instead of null so the row still shows
                return <span />;
            case 1: // Currency
                return this._renderCurrencyCell(product);
            case 2: // DateTime
                return this._renderDateTimeCell(product);
            case 3: // Decimal
                return this._renderDecimalCell(product);
            case 4: // Integer
                return this._renderIntegerCell(product);
            case 5: // Text
                return this._renderTextCell(product);
            case 6: // TrueFalse
                return this._renderTrueFalseCell(product);
            case 40: // Video
                this.props.telemetry.warning('Got video specification type, not supported yet so skipping line');
                return null;
            case 41: // Image
                this.props.telemetry.warning('Got image specification type, not supported yet so skipping line');
                return null;
            default:
                this.props.telemetry.warning(`Got unknown specification type ${product.DataTypeValue} so skipping line`);
                return null;
        }
    }

    private _renderCurrencyCell(product: AttributeValue): JSX.Element | null {
        if (product.CurrencyValue !== null && product.CurrencyValue !== undefined) {
            return (
                <span>
                    {product.CurrencyCode}
                    {product.CurrencyValue}
                </span>
            );
        }

        return null;
    }

    private _renderDateTimeCell(product: AttributeValue): JSX.Element | null {
        if (product.DateTimeOffsetValue !== null && product.DateTimeOffsetValue !== undefined && product.DateTimeOffsetValue.toUTCString) {
            return <span>{product.DateTimeOffsetValue.toUTCString()}</span>;
        }

        return null;
    }

    private _renderIntegerCell(product: AttributeValue): JSX.Element | null {
        if (product.IntegerValue !== null && product.IntegerValue !== undefined) {
            return <span>{product.IntegerValue}</span>;
        }

        return null;
    }

    private _renderDecimalCell(product: AttributeValue): JSX.Element | null {
        if (product.FloatValue !== null && product.FloatValue !== undefined) {
            return <span>{product.FloatValue}</span>;
        }

        return null;
    }

    private _renderTextCell(product: AttributeValue): JSX.Element | null {
        if (product.TextValue !== null && product.TextValue !== undefined) {
            // tslint:disable-next-line
            return <span dangerouslySetInnerHTML={Msdyn365.getRichTextHtml(product.TextValue)}/>;
        }

        return null;
    }

    private _renderTrueFalseCell(product: AttributeValue): JSX.Element | null {
        // TODO 20369885 setting to default value is needed to work around a platform bug where
        // config string value does not get its default value.
        if (product.BooleanValue) {
            return <span>{this.props.resources.trueValueText ? this.props.resources.trueValueText : 'Yes'}</span>;
        } else {
            return <span>{this.props.resources.falseValueText ? this.props.resources.falseValueText : 'No'}</span>;
        }
    }
}

export default ProductSpecification;
